import { Typography } from 'antd'
import PageHeader from '@/shared/components/PageHeader'

export default function DashboardPage() {
  return (
    <div>
      <PageHeader title="Dashboard" subtitle="Spinning Mill ERP — Sprint 1" />
      <Typography.Text type="secondary">
        Welcome. Use the sidebar to navigate to Masters and Admin sections.
      </Typography.Text>
    </div>
  )
}
